import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '../lib/get-element-tag'

import hydrate from './components/hydrate'

const tag = getElementTag(__APP_NAME__, 'heiboks', __APP_VERSION__)

class AppElement extends BaseElement {
  name = tag
  #observer

  connectedCallback() {
    super.connectedCallback?.()

    // Log views
    // eslint-disable-next-line compat/compat
    this.#observer = new IntersectionObserver(
      (intersections) => {
        if (intersections[0]?.isIntersecting) {
          this.sendGaEvent({ eventAction: `VIEW` })
          this.#observer.disconnect()
        }
      },
      { threshold: [0.99] }
    )
    this.#observer.observe(this)
  }

  disconnectedCallback() {
    this.#observer?.disconnect()
  }

  render() {
    hydrate(this, this.preloadedState)

    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
